<script>
import UserService from "@/helpers/APIService/user.service";
import { answer_type } from "@/helpers/global.variable";
import { required } from "vuelidate/lib/validators";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      answer_type,
      input_type: "text",
      current_answer_type: "text",
      fields: [{ id: 1 }],
      is_btn_loading: false,
      custom_question: {
        booking_source: [],
        is_required: true,
        is_editable: true,
        question_text: "",
        answer_type: "text",
        id: null,
        is_edit: false,
        form_data: {
          max: 20,
          min: 10,
        },
        form_data_options: [
          {
            option: null,
          },
        ],
      },
      isError: false,
      errorMessages: null,
      submitted: false,
      isSaveAndAddNew: false,
    };
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  computed: {
    ...authComputed,
  },
  mounted() {
    this.isEditQuestion();
  },
  methods: {
    updateAnswerTypeOption() {
      this.custom_question.answer_type = this.custom_question.answer_type;
    },
    AddFormData() {
      this.custom_question.form_data_options.push({ option: null });
    },
    deleteRow(index) {
      if (confirm("Are you sure you want to delete this element?"))
        this.custom_question.form_data_options.splice(index, 1);
    },
    onSubmit() {
      this.submitted = true;
      this.is_btn_loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        let QuestionData = new FormData();

        const bookingSourceId = [];
        this.custom_question.booking_source.map((item) => {
          bookingSourceId.push(item.id);
        });
        if (this.custom_question.booking_source.length > 0) {
          bookingSourceId.map((item) => {
            QuestionData.append("booking_source", item);
          });
        }
        QuestionData.append("is_required", this.custom_question.is_required);
        QuestionData.append("is_editable", this.custom_question.is_editable);
        QuestionData.append(
          "question_text",
          this.custom_question.question_text
        );
        QuestionData.append("answer_type", this.custom_question.answer_type);

        if (
          this.custom_question.answer_type == "multi_select" ||
          this.custom_question.answer_type == "choice"
        ) {
          QuestionData.append(
            "form_data",
            JSON.stringify(this.custom_question.form_data_options)
          );
        } else {
          QuestionData.append(
            "form_data",
            JSON.stringify(this.custom_question.form_data)
          );
        }
        QuestionData.append("is_active", true);
        QuestionData.append("priority_order", 1);
        QuestionData.append("hotel", this.hotel.id);

        if (this.custom_question.is_edit == false) {
          UserService.createCustomQuestion(QuestionData).then(
            (question) => {
              this.is_btn_loading = false;
              this.submitted = false;
              if (!this.isSaveAndAddNew) {
                this.$emit(
                  "submitted",
                  question,
                  this.currentProps.questionEdit
                );
              } else {
                this.$emit("saveAndAddNew", question);
                this.custom_question = {
                  booking_source: [],
                  is_required: true,
                  is_editable: true,
                  question_text: "",
                  answer_type: "text",
                  id: null,
                  is_edit: false,
                  form_data: {
                    max: 20,
                    min: 10,
                  },
                  form_data_options: [
                    {
                      option: null,
                    },
                  ],
                };
              }
            },
            (error) => {
              this.is_btn_loading = false;
              errorHandler(error);
            }
          );
        } else {
          UserService.updateCustomQuestion(
            QuestionData,
            this.custom_question.id
          ).then(
            (question) => {
              this.is_btn_loading = false;
              this.submitted = false;
              this.$emit(
                "submitted",
                question,
                this.currentProps.questionEdit,
                this.currentProps.questionIndex
              );
            },
            (error) => {
              this.is_btn_loading = false;
              errorHandler(error);
            }
          );
        }
      }
    },
    isEditQuestion() {
      if (this.currentProps.questionEdit == true) {
        // this.currentProps.selectedQuestion
        let bookingSourceIds = [];
        this.currentProps.selectedQuestion.booking_source.map((source) => {
          bookingSourceIds.push(source.id);
        });

        this.custom_question.booking_source =
          this.currentProps.bookingSources.filter((source) => {
            return bookingSourceIds.includes(source.id);
          });
        this.custom_question.id = this.currentProps.selectedQuestion.id;
        this.custom_question.is_edit =
          this.currentProps.selectedQuestion.questionEdit;
        this.custom_question.is_required =
          this.currentProps.selectedQuestion.is_required;
        this.custom_question.is_editable =
          this.currentProps.selectedQuestion.is_editable;
        this.custom_question.question_text =
          this.currentProps.selectedQuestion.question_text;
        this.custom_question.answer_type =
          this.currentProps.selectedQuestion.answer_type;
        if (
          this.custom_question.answer_type == "multi_select" ||
          this.custom_question.answer_type == "choice"
        ) {
          this.custom_question.form_data_options =
            this.currentProps.selectedQuestion.form_data;
        } else {
          this.custom_question.form_data.min =
            this.currentProps.selectedQuestion.form_data.min;
          this.custom_question.form_data.max =
            this.currentProps.selectedQuestion.form_data.max;
        }
      }
    },
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
  },
  validations: {
    custom_question: {
      question_text: {
        required,
      },
      answer_type: {
        required,
      },
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>
          {{
            !this.currentProps.questionEdit
              ? "Add New Question"
              : "Update Question"
          }}
        </h4>
        <hr />
        <div class="float-end">
          <b-form-checkbox
            class="mb-2"
            plain
            v-model="custom_question.is_required"
            >Required<i
              class="mdi mdi-information-outline"
              v-b-popover.hover="'Question is required.'"
            ></i
          ></b-form-checkbox>
        </div>
        <label for="question"
          >Question <span class="text-danger">*</span></label
        >
        <textarea
          id="question"
          class="form-control mb-3"
          rows="3"
          placeholder="Add your questions here... 
            Like : What ? , Where ? , How ? , etc... "
          v-model="custom_question.question_text"
          :class="{
            'is-invalid': submitted && $v.custom_question.question_text.$error,
          }"
        ></textarea>
        <div
          v-if="submitted && $v.custom_question.question_text.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.custom_question.question_text.required"
            >Question is required.</span
          >
        </div>

        <div class="row">
          <div class="col-md-12">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label="Answer Type"
              label-for="answer_type"
            >
              <span slot="label"
                >Answer Type <span class="text-danger">*</span></span
              >
              <b-form-select
                class="form-select"
                id="answer_type"
                type="text"
                autocomplete="off"
                v-model="custom_question.answer_type"
                :options="answer_type"
                @change="updateAnswerTypeOption"
                :class="{
                  'is-invalid':
                    submitted && $v.custom_question.answer_type.$error,
                }"
              >
              </b-form-select>
            </b-form-group>
            <div
              v-if="submitted && $v.custom_question.answer_type.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.custom_question.answer_type.required"
                >Please select answer type.</span
              >
            </div>
          </div>
        </div>

        <!-- options -->
        <div
          class="row option_parts"
          id="options_title"
          v-if="
            custom_question.answer_type == 'multi_select' ||
            custom_question.answer_type == 'choice'
          "
        >
          <div class="editable-title">
            Answers <span class="text-danger">*</span>
          </div>
          <p>Customer can select one of the following:</p>
          <div
            v-for="(field, index) in custom_question.form_data_options"
            :key="index"
            class="mb-3"
          >
            <div class="row align-items-center">
              <div class="col-lg-1 editable-title text-center">
                <h5 class="mb-0">{{ index + 1 }}</h5>
              </div>

              <div class="col-lg-4">
                <input
                  id="text"
                  v-model="field.option"
                  type="text"
                  autocomplete="off"
                  placeholder="Option"
                  class="form-control"
                />
              </div>
              <div class="col-lg-2">
                <a href="#" @click="deleteRow(index)">
                  <i class="fa fa-trash-alt text-danger editable-title"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <a
                id="add_new_option"
                class="fw-bold option_parts cursor"
                @click="AddFormData"
                >+ Add Another</a
              >
            </div>
          </div>
        </div>

        <!-- additional options -->
        <div class="row">
          <div class="col-md-12 mt-2">
            <div role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h5 class="m-0">
                    <a
                      v-b-toggle.addition_question
                      class="text-dark"
                      href="javascript: void(0);"
                      >Additional Option</a
                    >
                  </h5>
                </b-card-header>
                <b-collapse
                  id="addition_question"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <!-- is editable field -->
                      <div class="col-md-12">
                        <div
                          class="d-flex align-items-center justify-content-between editable-div"
                        >
                          <div class="editable-title">Editable</div>
                          <div class="div-toggle">
                            <div class="form-check form-switch form-switch-md">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="custom_question.is_editable"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- short text -->
                      <div
                        class="row mt-3 short_text"
                        v-if="custom_question.answer_type == 'text'"
                      >
                        <div class="col-md-12">
                          <b-form-group
                            class="mb-3"
                            label="Minimum Character"
                            label-for="min_char"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="min_char"
                              type="number"
                              autocomplete="off"
                              min="1"
                              v-model="custom_question.form_data.min"
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group
                            class="mb-3"
                            label="Maximum Character"
                            label-for="max_char"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="max_char"
                              type="number"
                              autocomplete="off"
                              min="1"
                              v-model="custom_question.form_data.max"
                            ></b-form-input>
                          </b-form-group>
                        </div>
                      </div>

                      <!-- date -->
                      <div
                        class="row mt-3 date"
                        v-else-if="custom_question.answer_type == 'date'"
                      >
                        <div class="col-md-12">
                          <b-form-group
                            class="mb-3"
                            label="Minimum Date"
                            label-for="min_date"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="min_date"
                              type="date"
                              v-model="custom_question.form_data.min"
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group
                            class="mb-3"
                            label="Maximum Date"
                            label-for="max_date"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="max_date"
                              type="date"
                              v-model="custom_question.form_data.max"
                            ></b-form-input>
                          </b-form-group>
                        </div>
                      </div>

                      <!-- number -->
                      <div
                        class="row mt-3 number"
                        v-else-if="custom_question.answer_type == 'number'"
                      >
                        <div class="col-md-12">
                          <b-form-group
                            class="mb-3"
                            label="Minimum Number"
                            label-for="min_num"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="min_num"
                              type="number"
                              autocomplete="off"
                              value="10"
                              min="1"
                              v-model="custom_question.form_data.min"
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group
                            class="mb-3"
                            label="Maximum Number"
                            label-for="max_num"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="max_num"
                              type="number"
                              autocomplete="off"
                              value="20"
                              min="1"
                              v-model="custom_question.form_data.max"
                            ></b-form-input>
                          </b-form-group>
                        </div>
                      </div>

                      <!-- long text -->
                      <div
                        class="row mt-3 long_text"
                        v-else-if="custom_question.answer_type == 'long_text'"
                      >
                        <div class="col-md-12">
                          <b-form-group
                            class="mb-3"
                            label="Minimum Character"
                            label-for="min_char"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="min_char"
                              type="number"
                              autocomplete="off"
                              min="1"
                              v-model="custom_question.form_data.min"
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group
                            class="mb-3"
                            label="Maximum Character"
                            label-for="max_char"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="max_char"
                              type="number"
                              autocomplete="off"
                              min="1"
                              v-model="custom_question.form_data.max"
                            ></b-form-input>
                          </b-form-group>
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>

        <!-- select booking source -->
        <div class="row">
          <div class="col-md-12">
            <div role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h5 class="m-0">
                    <a
                      v-b-toggle.booking_source
                      class="text-dark"
                      href="javascript: void(0);"
                      >Booking Source</a
                    >
                  </h5>
                </b-card-header>
                <b-collapse id="booking_source" visible>
                  <b-card-body>
                    <b-card-text class="mt-3">
                      <div class="row">
                        <div class="col-md-8">
                          <div class="form-group">
                            <label for="title_text"
                              >Select Booking Source
                              <span class="text-danger">*</span>
                            </label>
                            <b-button-group class="float-end">
                              <b-button
                                size="sm"
                                variant="outline-primary"
                                @click="
                                  custom_question.booking_source =
                                    currentProps.bookingSources
                                "
                                >Attach All</b-button
                              >
                              <b-button
                                size="sm"
                                variant="outline-primary"
                                @click="custom_question.booking_source = []"
                                >Detach All</b-button
                              >
                            </b-button-group>
                            <multiselect
                              v-model="custom_question.booking_source"
                              track-by="name"
                              label="name"
                              class="mt-3"
                              placeholder="Select Booking Sources"
                              :options="currentProps.bookingSources"
                              :multiple="true"
                              :taggable="true"
                              :show-labels="false"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                ><strong> {{ option.name }}</strong></template
                              >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-4"></div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>

        <!-- save button div -->
        <div class="row">
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              v-if="this.currentProps.questionEdit === false"
              class="float-end ms-2"
              variant="outline-primary"
              type="submit"
              @click="saveAndAddNew"
              :class="{
                disabled: isSaveAndAddNew === true && is_btn_loading,
              }"
            >
              <i
                v-if="isSaveAndAddNew === true && is_btn_loading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i
              >Save & Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="float-end ms-2"
              type="submit"
              @click="onSubmit"
              :class="{
                disabled: isSaveAndAddNew !== true && is_btn_loading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isSaveAndAddNew !== true && is_btn_loading"
              ></i>
              {{ currentProps.questionEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
